<template>
  <section class="w-full h-auto flex md:flex-row flex-col relative">
    <svg
      class="absolute hidden md:block right-0 bottom-0"
      width="232"
      height="232"
      viewBox="0 0 232 232"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M150.387 150.076C128.676 171.788 116.479 201.234 116.479 231.939L232.25 231.939L232.25 116.168C201.545 116.168 172.098 128.365 150.387 150.076Z"
        fill="#FFB201"
      />
      <path
        d="M181.088 186.745C167.586 198.747 160 215.026 160 232L232 232L232 168C212.904 168 194.591 174.743 181.088 186.745Z"
        fill="white"
      />
      <path
        d="M198.341 34.3046C176.63 12.5933 147.183 0.395993 116.479 0.395996L116.479 116.167L232.25 116.167C232.25 85.4629 220.053 56.016 198.341 34.3046Z"
        fill="#009F49"
      />
      <path
        d="M34.6157 150.076C12.9043 171.787 0.707029 201.234 0.707031 231.939L116.478 231.939L116.478 116.167C85.7739 116.167 56.327 128.365 34.6157 150.076Z"
        fill="#FFF27F"
      />
    </svg>

    <div
      class="
        feature-side
        w-full
        pl-5
        pr-5
        md:pl-118
        pt-16
        md:pt-104
        pb-56px
        bg-pelpaylemongreen200
      "
    >
      <div
        data-aos="fade-up"
        data-aos-duration="2000"
        class="feature-card-wrapper flex space-x-5"
      >
        <div class="icon">
          <svg
            width="63"
            height="63"
            viewBox="0 0 63 63"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              opacity="0.3"
              x="0.678467"
              y="0.0982056"
              width="62.25"
              height="62.25"
              rx="31.125"
              fill="#4640DD"
            />
            <path
              d="M26.6157 20.8483H38.2876L35.6938 25.3873L38.2876 29.9264H26.6157V20.8483Z"
              fill="white"
            />
            <path
              d="M41.7205 38.8519V36.1492C41.7205 35.5352 41.2228 35.0375 40.6089 35.0375H27.226V30.4603H38.0174C38.9052 30.4603 39.4348 29.4708 38.9423 28.7321L36.5344 25.1203L38.9423 21.5084C39.4348 20.7697 38.9052 19.7802 38.0174 19.7802H27.226V19.0173C27.226 18.596 26.8845 18.2545 26.4631 18.2545C26.0418 18.2545 25.7003 18.596 25.7003 19.0173V19.7802V30.4603V35.0375H22.9976C22.3836 35.0375 21.8859 35.5352 21.8859 36.1492V38.8519H19.9461C19.3322 38.8519 18.8345 39.3496 18.8345 39.9635V43.0803C18.8345 43.6943 19.3322 44.192 19.9461 44.192H43.6604C44.2743 44.192 44.772 43.6943 44.772 43.0803V39.9635C44.772 39.3496 44.2743 38.8519 43.6604 38.8519H41.7205ZM37.2436 21.3059L34.7007 25.1203L37.2436 28.9346H27.226V21.3059H37.2436ZM23.4117 36.5633H40.1948V38.8519H23.4117V36.5633ZM43.2462 42.6662H20.3602V40.3776H21.8859H41.7205H43.2462V42.6662Z"
              fill="#4640DD"
            />
          </svg>
        </div>

        <div class="card-content">
          <h4 class="font-medium text-26px leading-120 text-primarydark">
            Ownership
          </h4>
          <p class="text-17px text-pelpaygray300 max-w-360px leading-160">
            Ownership underpin our spirit of ownership, and commitment to drive
            mission forward.
          </p>
        </div>
      </div>

      <div
        data-aos="fade-up"
        data-aos-duration="2000"
        class="feature-card-wrapper flex space-x-5"
      >
        <div class="icon">
          <svg
            width="63"
            height="63"
            viewBox="0 0 63 63"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              opacity="0.3"
              x="0.678467"
              y="0.388428"
              width="62.25"
              height="62.25"
              rx="31.125"
              fill="#1EBCB4"
            />
            <rect
              x="20.1311"
              y="28.9197"
              width="2.59375"
              height="7.78125"
              fill="white"
            />
            <ellipse
              cx="31.8032"
              cy="41.8884"
              rx="1.29687"
              ry="1.29687"
              fill="white"
            />
            <rect
              x="40.8816"
              y="28.9197"
              width="2.59375"
              height="7.78125"
              fill="white"
            />
            <path
              d="M44.0121 27.4978H41.4867C41.0978 22.4958 36.9033 18.5447 31.8032 18.5447C26.7032 18.5447 22.5087 22.4958 22.1198 27.4978H19.5944C19.1747 27.4978 18.8345 27.8381 18.8345 28.2577V36.397C18.8345 36.8166 19.1747 37.1569 19.5944 37.1569H22.8501C23.2697 37.1569 23.61 36.8166 23.61 36.397V28.2577C23.61 23.7399 27.2854 20.0645 31.8032 20.0645C36.321 20.0645 39.9965 23.7399 39.9965 28.2577V36.397C39.9965 39.1195 37.7815 41.3346 35.0589 41.3346H34.0663C33.7481 40.3895 32.8541 39.7067 31.8032 39.7067C30.4866 39.7067 29.4155 40.7779 29.4155 42.0945C29.4155 43.411 30.4866 44.4822 31.8032 44.4822C32.8541 44.4822 33.7481 43.7994 34.0663 42.8543H35.0589C38.3624 42.8543 41.094 40.3606 41.4713 37.1569H44.0121C44.4317 37.1569 44.772 36.8166 44.772 36.397V28.2577C44.772 27.8381 44.4317 27.4978 44.0121 27.4978ZM22.0902 35.6371H20.3542V29.0176H22.0902V35.6371ZM31.8032 42.9624C31.3246 42.9624 30.9352 42.573 30.9352 42.0945C30.9352 41.6159 31.3246 41.2265 31.8032 41.2265C32.2818 41.2265 32.6712 41.6159 32.6712 42.0945C32.6712 42.573 32.2818 42.9624 31.8032 42.9624ZM43.2522 35.6371H41.5163V29.0176H43.2522V35.6371Z"
              fill="#1EBCB4"
            />
            <path
              d="M37.3848 27.5557C37.1009 27.4381 36.7741 27.503 36.5567 27.7203C36.5567 27.7203 34.1842 30.092 33.0593 31.2161C32.5541 31.724 32.2644 32.4258 32.2644 33.1413C32.2644 33.5609 32.6046 33.9012 33.0243 33.9012H36.3341V35.583C36.3341 36.0027 36.6743 36.3429 37.0939 36.3429C37.5136 36.3429 37.8538 36.0027 37.8538 35.583V33.9012H37.9078C38.3275 33.9012 38.6677 33.5609 38.6677 33.1413C38.6677 32.7216 38.3275 32.3814 37.9078 32.3814H37.8538V28.2577C37.8538 27.9504 37.6687 27.6734 37.3848 27.5557ZM36.3341 32.3814H34.053C34.0788 32.3494 34.1063 32.3187 34.1353 32.2894C34.7045 31.7207 35.5946 30.831 36.3341 30.0918V32.3814Z"
              fill="#1EBCB4"
            />
            <path
              d="M30.9355 35.583C30.9355 35.1633 30.5953 34.8231 30.1756 34.8231H27.1347C27.1605 34.7911 27.188 34.7604 27.217 34.7312C28.3403 33.6087 30.7129 31.2369 30.7129 31.2369C30.8554 31.0944 30.9356 30.901 30.9356 30.6995V30.2925C30.9356 28.7515 29.6819 27.4978 28.1409 27.4978C26.5846 27.4978 25.3462 28.7588 25.3462 30.2917V30.2925C25.3462 30.7121 25.6864 31.052 26.1061 31.052C26.5257 31.052 26.866 30.7113 26.866 30.2917C26.866 29.5951 27.4268 29.0176 28.1409 29.0176C28.8439 29.0176 29.4158 29.5895 29.4158 30.2925V30.3846C28.7996 31.0006 27.0569 32.7426 26.1411 33.6579C25.6359 34.1658 25.3462 34.8675 25.3462 35.583C25.3462 36.0027 25.6864 36.3429 26.1061 36.3429H30.1757C30.5953 36.3429 30.9355 36.0027 30.9355 35.583Z"
              fill="#1EBCB4"
            />
          </svg>
        </div>

        <div class="card-content">
          <h4 class="font-medium text-26px leading-120 text-primarydark">
            Supportive
          </h4>
          <p class="text-17px text-pelpaygray300 max-w-360px leading-160">
            We don’t stop until we nail it. Then we keep going. We stand
            together to stand tall.
          </p>
        </div>
      </div>

      <div
        data-aos="fade-up"
        data-aos-duration="2000"
        class="feature-card-wrapper flex space-x-5"
      >
        <div class="icon">
          <svg
            width="63"
            height="63"
            viewBox="0 0 63 63"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              opacity="0.3"
              x="0.678467"
              y="0.678589"
              width="62.25"
              height="62.25"
              rx="31.125"
              fill="#FFB201"
            />
            <ellipse
              cx="35.0454"
              cy="32.452"
              rx="8.42969"
              ry="8.42969"
              fill="white"
            />
            <path
              d="M35.6324 31.5862L35.2394 31.1932L34.0192 29.9729C33.9395 29.8933 33.8103 29.8932 33.7305 29.973C33.6509 30.0526 33.6508 30.1818 33.7306 30.2615L35.4881 32.0191C35.5678 32.0988 35.697 32.0988 35.7767 32.0191L38.2198 29.576L38.2198 29.576C38.2994 29.4964 38.2995 29.3672 38.2198 29.2874L35.6324 31.5862ZM35.6324 31.5862L36.0254 31.1932L37.9311 29.2875C37.9311 29.2875 37.9311 29.2875 37.9311 29.2875C38.0109 29.2078 38.1401 29.2078 38.2198 29.2874L35.6324 31.5862Z"
              fill="#FFB201"
              stroke="#FFB201"
              stroke-width="1.11161"
            />
            <path
              d="M30.3166 24.9798L30.5054 24.9866L30.6593 24.8769C36.2879 20.8636 44.2162 24.8762 44.2162 31.8748C44.2162 36.5831 40.4044 40.4587 35.6323 40.4588C33.8283 40.4588 32.1017 39.9019 30.6593 38.8729L30.5051 38.7628L30.3157 38.7699C30.319 38.7698 30.2737 38.7699 30.1802 38.77C30.1049 38.77 29.9985 38.7702 29.8613 38.7703L28.6463 38.7707C27.6443 38.771 26.3128 38.7711 24.98 38.7711C22.5837 38.7712 20.1835 38.771 19.6869 38.771L19.5944 38.771C19.4817 38.771 19.3903 38.6796 19.3903 38.5669C19.3903 38.4542 19.4817 38.3628 19.5944 38.3628H28.6795H29.8865L29.1018 37.4457C27.9427 36.091 27.2256 34.3941 27.0779 32.5894L27.0361 32.0789H26.524H22.1147C22.002 32.0789 21.9106 31.9875 21.9106 31.8748C21.9106 31.7621 22.002 31.6708 22.1147 31.6708H26.524H27.0362L27.078 31.1603C27.226 29.3528 27.9449 27.6567 29.1018 26.3039L29.886 25.3869H28.6794H24.9316C24.8189 25.3869 24.7275 25.2955 24.7275 25.1828C24.7275 25.0701 24.8189 24.9787 24.9316 24.9787H30.2945C30.2995 24.979 30.3073 24.9795 30.3166 24.9798ZM27.4566 31.8748C27.4566 36.4314 31.1514 40.0505 35.6323 40.0505C40.1664 40.0505 43.808 36.3719 43.808 31.8748C43.808 24.6816 35.1783 21.0291 30.0045 25.9447C28.3627 27.5039 27.4566 29.6124 27.4566 31.8748Z"
              fill="#FFB201"
              stroke="#FFB201"
              stroke-width="1.11161"
            />
            <path
              d="M35.9212 26.9187C35.9212 27.0782 35.7919 27.2075 35.6324 27.2075C35.4729 27.2075 35.3436 27.0782 35.3436 26.9187C35.3436 26.7592 35.4729 26.6299 35.6324 26.6299C35.7919 26.6299 35.9212 26.7592 35.9212 26.9187Z"
              fill="#FFB201"
              stroke="#FFB201"
              stroke-width="1.11161"
            />
            <path
              d="M35.6324 37.6754C36.0988 37.6754 36.4769 37.2973 36.4769 36.8309C36.4769 36.3644 36.0988 35.9863 35.6324 35.9863C35.166 35.9863 34.7878 36.3644 34.7878 36.8309C34.7878 37.2973 35.166 37.6754 35.6324 37.6754Z"
              fill="#FFB201"
            />
            <path
              d="M40.5601 31.0021C40.0937 31.0021 39.7156 31.3802 39.7156 31.8467C39.7156 32.3131 40.0937 32.6912 40.5601 32.6912C41.0266 32.6912 41.4047 32.3131 41.4047 31.8467C41.4047 31.3802 41.0265 31.0021 40.5601 31.0021Z"
              fill="#FFB201"
            />
            <path
              d="M30.7798 32.6812C31.2402 32.6065 31.5529 32.1728 31.4783 31.7125C31.4036 31.2521 30.9699 30.9394 30.5096 31.014C30.0492 31.0887 29.7365 31.5224 29.8112 31.9827C29.8858 32.4431 30.3195 32.7558 30.7798 32.6812Z"
              fill="#FFB201"
            />
          </svg>
        </div>

        <div class="card-content">
          <h4 class="font-medium text-26px leading-120 text-primarydark">
            Innovative
          </h4>
          <p class="text-17px text-pelpaygray300 max-w-360px leading-160">
            Creating a future-proof digital payment platform for Africa takes a
            trailblazing team —
          </p>
        </div>
      </div>

      <div
        data-aos="fade-up"
        data-aos-duration="2000"
        class="feature-card-wrapper flex space-x-5"
      >
        <div class="icon">
          <svg
            width="63"
            height="64"
            viewBox="0 0 63 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              opacity="0.3"
              x="0.678467"
              y="0.968765"
              width="62.25"
              height="62.25"
              rx="31.125"
              fill="#4EB2F9"
            />
            <g clip-path="url(#clip0)">
              <path
                d="M28.561 27.5547H35.0454V30.1485L31.8032 31.4453L28.561 30.1485V27.5547Z"
                fill="white"
              />
              <path
                d="M28.5608 21.0703L31.803 20.4219L34.3967 21.0703L35.6936 24.3125H27.9124L28.5608 21.0703Z"
                fill="white"
              />
              <path
                d="M27.9124 35.9844H35.6936V39.875L31.803 43.7656L27.9124 39.875V35.9844Z"
                fill="white"
              />
              <path
                d="M33.7184 26.4727C33.9702 26.4727 34.1743 26.2686 34.1743 26.0168V25.8806C34.1743 25.6288 33.9702 25.4247 33.7184 25.4247C33.4666 25.4247 33.2625 25.6288 33.2625 25.8806V26.0168C33.2625 26.2686 33.4666 26.4727 33.7184 26.4727Z"
                fill="#4EB2F9"
                stroke="#4EB2F9"
                stroke-width="0.333482"
              />
              <path
                d="M45.4825 30.9802C45.8866 30.384 46.123 29.6651 46.123 28.892C46.123 26.8165 44.4198 25.1315 42.3387 25.1631C40.3741 25.1931 38.7512 26.774 38.6713 28.7371C38.6376 29.5651 38.8755 30.337 39.3028 30.9711C38.7972 31.2635 38.2753 31.7111 37.8183 32.5088C36.876 32.079 35.7659 31.8451 34.8205 31.6461C34.5951 31.5987 34.3776 31.5528 34.1743 31.5069V31.1224C35.1817 30.5177 35.9233 29.6116 35.9233 28.7593C35.9233 28.6592 35.9146 28.5687 35.8987 28.4866C35.94 28.3927 35.978 28.2989 36.0127 28.2052C37.0036 28.1024 37.7154 27.5445 37.7154 26.8286L37.7189 25.8187C37.7189 25.3097 37.3127 24.9111 36.7942 24.9111H36.2874L36.2886 23.8267C36.2904 22.5938 35.7998 21.5536 34.8698 20.8184C34.0668 20.1836 32.9883 19.8269 31.833 19.8141C31.8296 19.814 31.8263 19.814 31.8229 19.8141C30.6675 19.8269 29.589 20.1836 28.7861 20.8184C27.8561 21.5536 27.3654 22.5938 27.3672 23.826V24.9111H26.8599C26.3414 24.9111 25.9352 25.3098 25.9352 25.8202L25.9387 26.8285C25.941 27.5445 26.6526 28.1015 27.6413 28.2049C27.6761 28.2989 27.7143 28.393 27.7557 28.4873C27.7398 28.5693 27.7308 28.6593 27.7308 28.7594C27.7308 29.6115 28.4724 30.5174 29.4799 31.122V31.507C29.2766 31.5529 29.0591 31.5987 28.8336 31.6461C27.8754 31.8479 26.748 32.0854 25.7977 32.5265C25.3376 31.7179 24.8116 31.2666 24.3026 30.9719C24.7304 30.3375 24.9685 29.565 24.9347 28.7366C24.8544 26.7729 23.2304 25.192 21.2653 25.1631C19.184 25.1325 17.4812 26.8171 17.4812 28.8919C17.4812 29.6653 17.7179 30.3844 18.1225 30.9807C16.9632 31.6955 16.2405 32.9622 16.2405 34.3475V36.397C16.2405 37.16 16.859 37.7786 17.622 37.7786H21.7229C21.9725 37.7786 22.1902 37.5862 22.1977 37.3367C22.2055 37.0785 21.9984 36.8667 21.7419 36.8667H17.6218C17.3625 36.8667 17.1523 36.6565 17.1523 36.3973V34.3475C17.1523 33.2294 17.7652 32.2119 18.7359 31.679C18.9182 31.841 19.1164 31.9852 19.3279 32.1095L20.8629 35.3528C20.9383 35.5121 21.0988 35.6137 21.275 35.6137H21.2769C21.4534 35.6137 21.6138 35.5112 21.6879 35.3511L23.2283 32.0248C23.3907 31.9198 23.5446 31.8027 23.6884 31.6745C24.1211 31.8931 24.584 32.2343 25.0061 32.9785C24.3595 33.4367 23.8892 34.0546 23.769 34.9166L23.1131 39.0411C23.1093 39.0646 23.1074 39.0884 23.1074 39.1123V41.1822C23.1074 41.8454 23.646 42.3846 24.3081 42.3846H27.9196C28.3695 42.3846 28.7829 42.2241 29.1051 41.9567L31.2449 44.0777C31.3951 44.2278 31.5943 44.3675 31.8143 44.3735C32.0367 44.3796 32.2626 44.2343 32.4109 44.0777L34.5106 41.9956C34.8255 42.2393 35.22 42.3846 35.6486 42.3846H39.2584C39.921 42.3846 40.4608 41.8454 40.4608 41.1822V39.1123C40.4608 39.1083 40.4586 39.0664 40.4563 39.0496L39.8859 34.9215C39.7647 34.0415 39.2792 33.4155 38.6136 32.9541C39.0312 32.2266 39.4888 31.8899 39.9169 31.6738C40.0609 31.8024 40.2151 31.9196 40.3777 32.0248L41.9181 35.3511C41.9923 35.5112 42.1527 35.6137 42.3291 35.6137H42.331C42.5072 35.6137 42.6677 35.5121 42.7431 35.3528L44.2784 32.1088C44.4895 31.9847 44.6874 31.8405 44.8693 31.6786C45.8404 32.2114 46.4536 33.2291 46.4536 34.3475V36.397C46.4536 36.656 46.2422 36.8667 45.9825 36.8667H41.8814C41.6317 36.8667 41.414 37.059 41.4066 37.3086C41.3988 37.5668 41.6058 37.7786 41.8623 37.7786H45.9825C46.745 37.7786 47.3655 37.1588 47.3655 36.397V34.3475C47.3655 32.9618 46.6423 31.6948 45.4825 30.9802ZM36.2869 26.7511V25.8229H36.7943C36.7999 25.8229 36.8041 25.8238 36.807 25.8247L36.8036 26.8269C36.8036 26.9572 36.5979 27.1322 36.256 27.2319C36.2765 27.0706 36.2869 26.9102 36.2869 26.7511ZM26.8506 26.8254L26.8472 25.8247C26.85 25.8238 26.8543 25.8229 26.8599 25.8229H27.3672V26.7511C27.3672 26.91 27.3776 27.0702 27.3981 27.2313C27.0567 27.1311 26.851 26.9559 26.8506 26.8254ZM21.2705 34.0824L20.5508 32.5618C20.7648 32.6001 20.9847 32.6212 21.2095 32.6212C21.4754 32.6212 21.7346 32.5927 21.985 32.5395L21.2705 34.0824ZM24.0144 29.1498C23.8942 30.4948 22.8115 31.578 21.4666 31.6979C19.7117 31.8544 18.2477 30.3896 18.4046 28.6341C18.5248 27.2891 19.6075 26.2059 20.9525 26.086C22.7073 25.9295 24.1713 27.3943 24.0144 29.1498ZM28.2792 23.8253C28.2761 21.725 30.1156 20.7468 31.828 20.7259C33.5403 20.7468 35.3799 21.725 35.3768 23.8254L35.3762 24.3014C34.5099 23.7219 33.2372 23.3769 31.836 23.3769C31.8306 23.3769 31.8252 23.3769 31.8198 23.3769C30.4185 23.3769 29.1455 23.7217 28.2791 24.3008V23.8253H28.2792ZM28.4383 27.7176C28.4293 27.6897 28.4212 27.6615 28.4126 27.6335C28.3246 27.3327 28.2792 27.0375 28.2792 26.7511V25.513C28.8505 24.7749 30.2484 24.2872 31.8275 24.2888C31.8303 24.2887 31.8332 24.2888 31.8361 24.2888C33.4094 24.2888 34.8047 24.7762 35.3751 25.513V26.7511C35.3751 27.0641 35.3211 27.3876 35.216 27.7175C35.0742 27.6539 34.9275 27.6018 34.782 27.5472C33.5254 27.0679 32.67 26.8709 31.8298 26.8674C31.8286 26.8674 31.8274 26.8674 31.8261 26.8674C30.9847 26.8709 30.1289 27.0679 28.8733 27.5468C28.7274 27.6015 28.5804 27.6539 28.4383 27.7176ZM28.6428 28.7592C28.6428 28.7583 28.6428 28.7573 28.6428 28.7564C28.643 28.6754 28.6901 28.6021 28.7626 28.5661C28.9242 28.4857 29.1972 28.3992 29.1972 28.3992C30.3427 27.9623 31.1051 27.7826 31.828 27.7793C32.5497 27.7826 33.3116 27.9623 34.4583 28.3997C34.5954 28.4512 34.7363 28.4986 34.864 28.5712C34.9378 28.6131 35.0115 28.6668 35.0115 28.7592C35.0115 29.5425 33.4389 30.9021 31.828 30.9148C30.2162 30.9021 28.6428 29.5425 28.6428 28.7592ZM33.2624 31.5562V31.8671C33.2624 32.2719 33.127 32.5892 32.8601 32.8101C32.6148 33.0132 32.2703 33.1249 31.8902 33.1249C31.2878 33.1249 30.3918 32.79 30.3918 31.8671V31.5558C30.8582 31.7242 31.3472 31.8233 31.8249 31.8266H31.828C31.828 31.8266 31.83 31.8266 31.8311 31.8266C32.3082 31.8233 32.7965 31.7243 33.2624 31.5562ZM29.0215 32.5384C29.2039 32.5 29.3811 32.4627 29.5515 32.4252C29.8304 33.4758 30.887 34.0368 31.8902 34.0368C32.4821 34.0368 33.0331 33.8507 33.4415 33.5125C33.7824 33.2305 34.0083 32.861 34.1108 32.4269C34.2788 32.4638 34.4532 32.5006 34.6327 32.5383C34.7624 32.5656 34.8944 32.5935 35.0278 32.6221L32.6955 35.7303C32.3789 35.8813 32.0836 36.0777 31.8274 36.3078C31.5708 36.0777 31.2754 35.8813 30.9588 35.7304L28.6265 32.6221C28.7598 32.5935 28.8918 32.5657 29.0215 32.5384ZM24.6702 35.0552C24.6707 35.0521 24.6712 35.049 24.6716 35.0458C24.8433 33.8 26.2055 33.2231 27.656 32.8481L29.573 35.4029C28.9321 35.4046 28.2984 35.6295 27.7829 36.1631C27.1252 36.8452 26.8303 37.7631 26.8984 38.6561H24.0976L24.6702 35.0552ZM28.4516 41.3091C28.2996 41.4124 28.1166 41.4726 27.9196 41.4726H24.3081C24.1488 41.4726 24.0193 41.3425 24.0193 41.182V39.568H27.9196C27.9871 39.568 28.0528 39.5753 28.116 39.5887C28.519 39.6738 28.8291 40.0154 28.8662 40.4355C28.8686 40.4635 28.8698 40.4914 28.8698 40.52C28.8698 40.8483 28.7039 41.1376 28.4516 41.3091ZM33.7849 40.4991C33.7818 40.7742 33.8387 41.0368 33.9434 41.2732L31.8279 43.3717L29.6485 41.2118C29.7343 40.9978 29.7817 40.7644 29.7817 40.52C29.7817 39.492 28.9464 38.6561 27.9196 38.6561H27.8108C27.7403 37.9935 27.95 37.3041 28.4388 36.7965C29.2163 35.9917 30.454 36.2968 31.2255 36.9935C31.2777 37.0397 31.3191 37.0798 31.3537 37.112C31.4808 37.2324 31.6115 37.3564 31.8279 37.3564C32.0431 37.3564 32.1726 37.233 32.2984 37.1139C32.3331 37.081 32.3756 37.0409 32.4297 36.9923C33.2006 36.2968 34.4383 35.9917 35.2152 36.7959C35.7045 37.3035 35.9143 37.9929 35.8438 38.6561H35.687C34.6594 38.6561 33.7961 39.4716 33.7849 40.4991ZM39.549 41.182C39.549 41.3418 39.4182 41.4726 39.2584 41.4726H35.6486C35.4735 41.4726 35.31 41.4252 35.169 41.3425C34.8881 41.1784 34.6991 40.8738 34.6966 40.5261V40.52C34.6966 40.0288 35.0693 39.6239 35.5471 39.5735C35.5805 39.5698 35.6146 39.568 35.6486 39.568H39.549V41.182ZM38.9826 35.046L39.4814 38.6562H36.7562C36.8237 37.7632 36.5289 36.8452 35.8711 36.1632C35.3558 35.6294 34.722 35.4046 34.0812 35.4029L35.9982 32.8482C37.4488 33.2231 38.811 33.8 38.9826 35.046ZM42.3354 34.0824L41.621 32.5395C41.8712 32.5927 42.1306 32.6212 42.3965 32.6212C42.6213 32.6212 42.8412 32.6001 43.0552 32.5617L42.3354 34.0824ZM42.3964 31.7094C40.7723 31.7094 39.4648 30.327 39.588 28.6767C39.6908 27.2998 40.8012 26.1874 42.1781 26.0829C43.8283 25.9576 45.2112 27.2662 45.2112 28.892C45.2112 30.4455 43.9485 31.7094 42.3964 31.7094Z"
                fill="#4EB2F9"
                stroke="#4EB2F9"
                stroke-width="0.333482"
              />
              <path
                d="M29.9357 26.4727C30.1875 26.4727 30.3916 26.2686 30.3916 26.0168V25.8806C30.3916 25.6288 30.1875 25.4247 29.9357 25.4247C29.6839 25.4247 29.4797 25.6288 29.4797 25.8806V26.0168C29.4797 26.2686 29.6839 26.4727 29.9357 26.4727Z"
                fill="#4EB2F9"
                stroke="#4EB2F9"
                stroke-width="0.333482"
              />
            </g>
            <defs>
              <clipPath id="clip0">
                <rect
                  width="31.125"
                  height="31.125"
                  fill="white"
                  transform="translate(16.2407 16.5313)"
                />
              </clipPath>
            </defs>
          </svg>
        </div>

        <div class="card-content">
          <h4 class="font-medium text-26px leading-120 text-primarydark">
            Authenticity
          </h4>
          <p class="text-17px text-pelpaygray300 max-w-360px leading-160">
            We believe that every person matters and we all take a transparent
            view on the status quo.
          </p>
        </div>
      </div>
    </div>
    <div class="right-side w-full pl-5 pr-5 md:pl-103 md:pr-106 pb-24">
      <div class="top-header w-full pt-10 md:pt-20 bg-cover">
        <h3
          data-aos="fade-up"
          data-aos-duration="1000"
          class="
            font-bold
            text-4xl
            md:text-5xl
            text-black
            md:leading-56px
            max-w-lg
            text-center
            md:text-left
          "
        >
          Payment. We get it Absolutly!
        </h3>
        <p
          data-aos="fade-up"
          data-aos-duration="2000"
          class="
            text-pelpaygray200
            leading-6
            text-base
            font-normal
            text-center
            md:text-left
            max-w-2xl
            mx-auto
            mt-6
          "
        >
          The dedication to our products shows. That’s why we’re so stoked to
          support you with exactly the kind of payment solutions you’re looking
          for.
        </p>
      </div>

      <div
        data-aos="fade-up"
        data-aos-duration="2000"
        class="info flex justify-between space-x-5 items-center mt-16"
      >
        <div class="trans-info">
          <h2
            class="
              text-pelpaygreen100 text-5xl
              md:text-56px
              font-bold
              leading-120
            "
          >
            300M+
          </h2>
          <p class="text-pelpaygray400 max-w-100px mt-3 text-base leading-160">
            Transactions every day
          </p>
        </div>

        <div class="trans-info">
          <h2
            class="
              text-pelpaygreen100 text-5xl
              md:text-56px
              font-bold
              leading-120
            "
          >
            1,000+
          </h2>
          <p class="text-pelpaygray400 max-w-150px mt-3 text-base leading-160">
            African businesses around the world
          </p>
        </div>
      </div>

      <div
        data-aos="fade-up"
        data-aos-duration="1000"
        class="
          button
          flex
          justify-center
          md:justify-start
          items-center
          space-x-5
          mt-10
          md:mt-16
        "
      >
        <router-link to="/">
          <button
            class="
              bg-primarygreen
              transition-all
              duration-500
              ease-in-out
              hover:bg-pelpayblue
              px-8
              py-4
              rounded-md
              leading-160
              tracking-0.02em
              font-semibold
              text-white
            "
          >
            Vew Documenation
          </button>
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style></style>
